import PropTypes from 'prop-types'

const entryType = {
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  nextSession: PropTypes.string,
  times: PropTypes.arrayOf(PropTypes.string),
  location: PropTypes.string,
  body: PropTypes.string.isRequired,
  link: PropTypes.string,
}

export default entryType
